/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_UnsupportedInputs */

const en_auth_unsupported = /** @type {(inputs: Auth_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser doesn't support passkeys.`)
};

const de_auth_unsupported = /** @type {(inputs: Auth_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Browser unterstützt keine Passkeys.`)
};

/**
* | output |
* | --- |
* | "This browser doesn't support passkeys." |
*
* @param {Auth_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_unsupported = /** @type {((inputs?: Auth_UnsupportedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_UnsupportedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_unsupported(inputs)
	return en_auth_unsupported(inputs)
});